export default "__VITE_ASSET__B35vIRzb__"